import { createAsyncTypes } from 'utils/ActionCreator'

const constantsKey = 'Settings/MicrosoftQuarantine'

export const GET_DATA_ASYNC = createAsyncTypes('GET_DATA', constantsKey)
export const UPDATE_DATA_ASYNC = createAsyncTypes('UPDATE_DATA', constantsKey)
export const TOGGLE_DETECTION_CHANGE = `${constantsKey}/TOGGLE_DETECTION_CHANGE`